import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import Text from '../Text';

interface Props {
  style?: StyleProp<ViewStyle>;

  color?: string;

  onPress?(): void;
}

const TodayBadge = ({ style, color, onPress }: Props) => (
  <Badge style={style} onPress={onPress}>
    <FontAwesomeIcon
      color={color || palette.primary_90}
      icon="star"
      size={16}
    />

    <TodayText
      color={color || palette.primary_90}
      variant="caption"
      weight="semibold"
    >
      Today
    </TodayText>
  </Badge>
);

const Badge = styled(TouchableOpacity)`
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  background-color: rgba(47, 57, 238, 0.1);
  border-radius: 20px;

  gap: 8px;
`;

const TodayText = styled(Text)<{ color: string }>`
  color: ${({ color }) => color};
`;

export default TodayBadge;
